import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "sup.colorScheme";
export const COLOR_SCHEMES = ["light", "dark", "system"];

const read = () => {
  const saved = localStorage.getItem(STORAGE_KEY);
  return COLOR_SCHEMES.includes(saved) ? saved : "system";
};

/**
 * Aplica el esquema al documento.
 * "system" no escribe atributo: así manda `prefers-color-scheme`, que es lo que
 * la hoja de tokens consulta.
 */
const apply = (scheme) => {
  const root = document.documentElement;
  if (scheme === "system") {
    root.removeAttribute("data-theme");
  } else {
    root.setAttribute("data-theme", scheme);
  }
};

/** Claro / oscuro / seguir al sistema, recordado entre sesiones. */
export const useColorScheme = () => {
  const [scheme, setScheme] = useState(read);

  useEffect(() => {
    apply(scheme);
    localStorage.setItem(STORAGE_KEY, scheme);
  }, [scheme]);

  // Con "sistema", seguir los cambios del sistema operativo en vivo.
  useEffect(() => {
    if (scheme !== "system" || !window.matchMedia) return undefined;
    const query = window.matchMedia("(prefers-color-scheme: dark)");
    const onChange = () => apply("system");
    query.addEventListener("change", onChange);
    return () => query.removeEventListener("change", onChange);
  }, [scheme]);

  return { scheme, setScheme: useCallback((next) => setScheme(next), []) };
};

/** Se llama antes de montar React para evitar el destello de tema claro. */
export const applyStoredColorScheme = () => apply(read());

export default useColorScheme;
